import * as Sentry from "@sentry/react";

export default function captureException(err: any): void {
    if (process.env.NODE_ENV === "development") {
        console.error(err);
        return;
    }
    Sentry.captureException(err);
}
